var quantityLabel = "Quantity";
var quantityFlyoutHeader = "Choose your quantity";
var quantityFlyoutCTA = "Select this quantity";
var closeButton = "Close";
var pricePlaceholder = "...";
var priceLabel = "Price";
var unitPriceLabel = "Unit price";
var incompatibilityMessage = "Not available with other selections: ";
var select = "Select...";
var percentSavings = "{{{PERCENT}}}% savings";
var sale = "sale";
var amountSavings = "{{{AMOUNT}}} savings/unit";
var amountSavingsWithSale = "{{{AMOUNT}}} savings/unit + sale";
var seeMoreQuantities = "See more quantities";
var required = "Required";
var sample = "Sample";
var estimatedQuantity = "Estimated quantity";
var numberOfRecipients = "{{{COUNT}}} Recipients";
var recommendedCallout = "Recommended";
var newCallout = "New";
var incompatibleLabel = "Incompatible";
var outOfStockCallout = "Out of stock";
var dismissAlert = "Dismiss alert";
var unwindingMessage_1 = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}} & {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} & {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Incompatible with more than {{{ATTRIBUTE_COUNT}}} options.";
var unwindingAlertMessage_1 = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} was unselected.";
var unwindingAlertMessage_2 = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} & {{{ATTRIBUTE2}}} {{{OPTION2}}} were unselected.";
var unwindingAlertMessage_3 = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} & {{{ATTRIBUTE3}}} {{{OPTION3}}} were unselected.";
var unwindingAlertMessage_more = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: More than {{{ATTRIBUTE_COUNT}}} options were unselected.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} to {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "At least {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Enter a value between {{{MINIMUM}}} to {{{MAXIMUM}}} pages, including cover ";
var rangePartialRangedHelperTextForBooklets = "At least {{{MINIMUM}}} pages, including cover ";
var rangedGeneralInputError = "Input is invalid";
var rangedBetweenRangesError = "Closest numbers are {{{LOWER}}} {{{UNIT}}} and {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Number can't exceed 8 decimals";
var rangedMinInputValueError = "The minimum number is {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "The maximum number is {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Input must be a number";
var requiredAttributeFieldError = "Enter a value between {{{LOWER}}} to {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Closest numbers are {{{LOWER}}} pages and {{{HIGHER}}} pages ";
var rangedMinInputValueErrorForBooklets = "The minimum number is {{{MINIMUM}}} pages ";
var rangedMaxInputValueErrorForBooklets = "The maximum number is {{{MAXIMUM}}} pages ";
var requiredAttributeFieldErrorForBooklets = "Enter a value between {{{LOWER}}} to {{{HIGHER}}} pages, including cover ";
var requiredInformationToast = "Please provide all required information.";
var enGb = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, enGb as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=en-gb.json.mjs.map
